import React from "react";
import { Row, Col, Typography, Space, Button, Modal } from "antd";
import Styles from "./BrowserBackButtonPopup.module.scss";

type Props = {
  isBrowserBackButtonPopup: boolean;
  handleCancelBrowserBackButtonPopup: () => void;
  handleOkBrowserBackButtonPopup: () => void;
};

const BrowserBackButtonPopup: React.FC<Props> = ({
  isBrowserBackButtonPopup,
  handleCancelBrowserBackButtonPopup,
  handleOkBrowserBackButtonPopup,
}) => {
  return (
    <Modal
      onOk={handleCancelBrowserBackButtonPopup}
      onCancel={handleCancelBrowserBackButtonPopup}
      visible={isBrowserBackButtonPopup}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      centered={true}
      footer={
        <Row className={Styles.modalContainer}>
          <Col span={24}>
            <Row justify="center">
              <Typography.Text className={Styles.modalHeader}>
                Back To Dashboard
              </Typography.Text>
            </Row>
            <Row justify="center" className={Styles.popupSection}>
              <Col>
                <p className={Styles.modalBodyText}>
                  Trip is successfully created, Do you want to navigate back to
                  Dashboard?
                </p>
              </Col>
            </Row>

            <Row justify="center" className={Styles.popupSection}>
              <Col className={Styles.modalBtn}>
                <Space>
                  <Button
                    className={Styles.modalCloseBtn}
                    onClick={handleCancelBrowserBackButtonPopup}
                  >
                    Cancel
                  </Button>

                  <Button
                    className={Styles.buttonThemeBlue}
                    onClick={handleOkBrowserBackButtonPopup}
                  >
                    Ok
                  </Button>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    />
  );
};

export default BrowserBackButtonPopup;
